export function alreadyLoadedReducer(prevState = false, action : any = {}) {
    switch (action.type) {
        case 'SET_LOADED':
            return true;
        default:
            return prevState;
    }
}
